import React, { useEffect, useState } from "react";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setPage,
  setRowsPerPage,
  setSearchValue,
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/DuesSlice";
import { useGetAllTransactionForExcelMutation } from "src/services/TransactionService";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
import moment from "moment";
import DuesListing from "./DuesListing";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
import { usePermission } from "src/hooks/usePermission";

type Props = {};

const DuesListingWrapper = (props: Props) => {
  const dispatch = useDispatch();
  const {
    items,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    isTableLoading,
    dateFilter,
  } = useSelector((state: RootState) => state.dues);
  // const [excelPayemnt, setExcelPayemnt] = React.useState([]);
  const [isOpenEditDialog, setIsOpenEditDialog] = useState(false);
  const [selectedDueAmountId, setSelectedDueAmountId] = useState<string>("");

  const [getDuesExcel, getPaymnetExcelInfo] =
    useGetAllTransactionForExcelMutation();
  const moduleName = "ORDER";

  const canEdit = usePermission(moduleName, "UPDATE");
  const columns: columnTypes[] = [
    { field: "orderNumber", headerName: "Order Number", flex: "flex-[1_1_0%]" },
    { field: "name", headerName: "Student Name", flex: "flex-[1_1_0%]" },
    { field: "mobile", headerName: "Mobile Number", flex: "flex-[1_1_0%]" },
    { field: "dueAmt", headerName: "Due Amount", flex: "flex-[1_1_0%]" },
    { field: "duedate", headerName: "Due Date", flex: "flex-[1_1_0%]" },
    {
      field: "action",
      headerName: "Actions",
      flex: "flex-[1_1_0%]",
      extraClasses: "",
      renderCell: (row: any) => {
        const options = [];

        if (canEdit) {
          options.push({
            label: "Edit",
            onClick: () => {
              setIsOpenEditDialog(true);
              setSelectedDueAmountId(row?._id);
            },
          });
        }

        return <ATMMenu options={options} />;
      },
    },
  ];
  return (
    <div>
      <DuesListing
        columns={columns}
        getDuesExcel={getDuesExcel}
        isloadingExcel={getPaymnetExcelInfo.isLoading}
        rows={items}
        // excelData={excelPayemntData}
        paginationProps={{
          isTableLoading,
          totalItems,
          page,
          rowsPerPage,
          searchValue,
          setPage: (newPage) => dispatch(setPage(newPage)),
          setRowsPerPage: (newRowsPerPage) =>
            dispatch(setRowsPerPage(newRowsPerPage)),
          setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
        }}
      />
      {/* {isOpenEditDialog && (
        <EditDueAmountWrapper
          onClose={() => setIsOpenEditDialog(false)}
          selectedDueAmountId={selectedDueAmountId}
        />
      )} */}
    </div>
  );
};

export default DuesListingWrapper;
